import { Tooltip } from "@material-ui/core";
import { isValid } from "date-fns";
import _ from "lodash";
import React from "react";
import { axiosNT } from "../../../services/axios";
import {
  convertSubjectIdFromObjectToString,
  extractContent,
} from "../../../utils";
import ACLService from "../../acl/services/aclService";
import contentService from "../../mylibrary/services/contentService";
import {
  ContentRequest,
  Owners,
  Question,
  RequestInfo,
  RequestInfoDetails,
  RequestPriority,
  Roles,
  Subject,
  Author,
} from "../types/ContentRequest";
import { RequestContentType } from "../types/ContentRequestCreate";
import moment from "moment";
import { QUESTION_TYPE, QUESTION_TYPES } from "../../../constants/comman";
import { EMPTY_PASSAGE_DATA } from "../components/SubQuestionsPopup";

const styles = {
  colorprimary: {
    color: "#1d7dea",
    cursor: "pointer",
  },
  customDropdownBox: {
    position: "absolute",
    marginTop: 130,
    background: "rgb(255 255 255)",
    border: "0.5px solid #999999",
    boxShadow: "0px 5px 2px rgba(0, 0, 0, 0.05)",
    borderRadius: 4,
    "& .deleteAction": {
      "& svg": {
        fill: "#F44335",
        margin: "0px 12px",
      },
      padding: "10px 12px",
      cursor: "pointer",
      "&:hover": {
        background: "rgb(102 102 102 / 3%)",
      },
    },
    "& .editAction": {
      "& svg": {
        fill: "#1d7dea",
        margin: "0px 12px",
      },
      padding: "10px 12px",
      cursor: "pointer",
      "&:hover": {
        background: "rgb(102 102 102 / 3%)",
      },
    },
    "&::after": {
      position: "absolute",
      content: '" "',
      top: -6,
      right: 9,
      width: 10,
      height: 10,
      background: "rgb(255 255 255)",
      borderRight: "0.5px solid #999999",
      borderTop: "0.5px solid #999999",
      transform: "rotate(-45deg)",
      webkitTransform: "rotate(-45deg)",
    },
  },
};
export const prioritiesToDisplay = [
  "Important and urgent",
  "Not Important but urgent",
  "Important but not urgent",
  "Not important and not urgent",
];
export const getIconBasedOnPriority = (priorityType: string) => {
  switch (priorityType) {
    case prioritiesToDisplay[0]:
      return "/assets/svg/contentRequest/important_urgent.svg";
      break;
    case prioritiesToDisplay[1]:
      return "/assets/svg/contentRequest/notImportant_urgent.svg";
      break;
    case prioritiesToDisplay[2]:
      return "/assets/svg/contentRequest/important_not_urgent.svg";
      break;
    case prioritiesToDisplay[3]:
      return "/assets/svg/contentRequest/noImportant_noUrgent.svg";
      break;
    default:
      return "/assets/svg/contentRequest/defaultpriority.svg";
  }
};
export const convertRequestPriorityToDislayValue = (
  priority: RequestPriority
) => {
  switch (priority) {
    case RequestPriority.IMPORTANT_AND_URGENT: {
      return prioritiesToDisplay[0];
    }
    case RequestPriority.IMPORTANT_BUT_NOT_URGENT: {
      return prioritiesToDisplay[2];
    }
    case RequestPriority.NOT_IMPORANT_AND_NOT_URGENT: {
      return prioritiesToDisplay[3];
    }
    case RequestPriority.NOT_IMPORTANT_BUT_URGENT: {
      return prioritiesToDisplay[1];
    }
    default: {
      return "";
    }
  }
};

export const convertPriorityDisplayValue = (priority: string) => {
  switch (priority) {
    case prioritiesToDisplay[0]: {
      return RequestPriority.IMPORTANT_AND_URGENT;
    }
    case prioritiesToDisplay[1]: {
      return RequestPriority.NOT_IMPORTANT_BUT_URGENT;
    }
    case prioritiesToDisplay[2]: {
      return RequestPriority.IMPORTANT_BUT_NOT_URGENT;
    }
    case prioritiesToDisplay[3]: {
      return RequestPriority.NOT_IMPORANT_AND_NOT_URGENT;
    }
    default: {
      return RequestPriority.IMPORTANT_AND_URGENT;
    }
  }
};

export const generateDefaultContentRequest = (
  type: RequestContentType
): ContentRequest => {
  const defaultContentRequest: ContentRequest = {
    title: "",
    completionPercent: 0,
    publishedOn: "",
    status: "draft",
    // progress: null,
    requestInfo: {
      orderNote: "",
      startDate: "",
      endDate: "",
      type,
      totalCount: 0,
      // priority: RequestPriority.IMPORTANT_AND_URGENT,
      owners: [],
      details: generateDefaultDetails(type),
    },
  };

  return defaultContentRequest;
};

const generateDefaultDetails = (
  type: RequestContentType
): RequestInfoDetails => {
  const details: RequestInfoDetails = {
    courseTypes: [],
    subjects: [],
  };

  if (type === RequestContentType.TEST) {
    details.testDetails = {
      name: "",
      contentRequestItemsId: null,
      authors: [],
    };
  }

  return details;
};

export const isLoggedInUserCenterHead = () => {
  const userData = ACLService.getUserDetailsFromStorage();
  const isBranchClient = _.get(
    userData,
    "authenticatedUser.clientId.isBranchClient",
    false
  );
  const isAdmin = _.get(userData, "authenticatedUser.isAdmin", false);

  return isBranchClient && isAdmin;
};

export const isLoggedInUserMultiCenterHead = () => {
  const userData = ACLService.getUserDetailsFromStorage();
  const role = _.get(userData, "authenticatedUser.role.role", undefined);
  const isAdmin = _.get(userData, "authenticatedUser.isAdmin", undefined);
  const isBranchClient = _.get(
    userData,
    "authenticatedUser.clientId.isBranchClient",
    undefined
  );
  const isSuperAdmin = _.get(
    userData,
    "authenticatedUser.isSuperAdmin",
    undefined
  );

  return (
    (!isBranchClient && (role === "National Head" || isAdmin === true)) ||
    isSuperAdmin
  );
};

const handleSingleOrderNoteAttachment = async (
  attachment: File,
  requestId: string
) => {
  try {
    const response = await contentService.generatePresignedUrl({
      key: attachment.name,
      id: requestId,
      location: "contentRequest",
    });
    const {
      data: { fields, url },
    } = response;
    const { key } = fields;

    await contentService.uploadAttachment({
      file: attachment,
      uploadUrl: url,
      s3Fields: fields,
    });

    return `${url}/${key}`;
  } catch (error) {
    throw error;
  }
};

export const preSaveRequestModifications = async (
  requestData: ContentRequest
) => {
  // Modify request data before saving
  const newRequestData: ContentRequest = JSON.parse(
    JSON.stringify(requestData)
  );
  try {
    const { requestInfo } = newRequestData;
    const subjects = _.get(requestInfo, "details.subjects", []);
    let totalCount =
      newRequestData.requestInfo.type === "question"
        ? 0
        : newRequestData.requestInfo.totalCount;
    const type = requestInfo.type;

    // Correctly set checked: true for subjects in questions
    subjects.forEach((subject: Subject) => {
      const { questions } = subject;
      questions.forEach((question) => {
        const { syllabus, count } = question;
        if (type === "question") {
          totalCount += count ? parseInt(count.toString()) : 0;
        }
        convertSubjectIdFromObjectToString(syllabus.subjects);
        convertSubjectIdFromObjectToString(syllabus.secondarySubjects);

        if (
          question.code.toString() === QUESTION_TYPES.PARAGRAPH.toString() &&
          question.passage.length === 0
        ) {
          question.passage.push(EMPTY_PASSAGE_DATA);
        }
        question.authors = question.authors.map((author) => {
          let name = author.name.split("|")[0].trim();
          author.name = name;
          return author;
        });
      });
    });
    newRequestData.requestInfo.totalCount = totalCount;

    // Save all attachments
    const { orderNoteAttachments } = requestData.requestInfo;

    if (orderNoteAttachments && orderNoteAttachments.length > 0) {
      const promiseArr = orderNoteAttachments.map(async (attachment) => {
        if (typeof attachment !== "string") {
          return await handleSingleOrderNoteAttachment(
            attachment,
            newRequestData._id || ""
          );
        }
        return attachment;
      });
      const resolvedAttachments = await Promise.all(promiseArr);
      newRequestData.requestInfo.orderNoteAttachments = resolvedAttachments;
    }
    if (
      newRequestData.requestInfo.type !== RequestContentType.TEST &&
      newRequestData.requestInfo.details.testDetails
    ) {
      delete newRequestData.requestInfo.details.testDetails;
    }
    // let subjects = _.get(requestInfo, "details.subjects", []);
    // subjects = subjects.map((subject: Subject) => {
    //   let { questions } = subject;
    //   questions = questions.map((question) => {
    //     question.authors = question.authors.map((author) => {
    //       let name = author.name.split('|')[0].trim()
    //       author.name = name;
    //       return author
    //     })
    //     return question;
    //   });
    //   subject.questions = questions
    //   return subject;
    // });
    //  newRequestData.requestInfo.details.subjects = subjects;
    if (newRequestData.requestInfo.details.testDetails) {
      let authors = _.get(requestInfo, "details.testDetails.authors", []);
      authors = authors.map((author: any) => {
        let name = author.name.split("|")[0].trim();
        author.name = name;
        return author;
      });
      newRequestData.requestInfo.details.testDetails.authors = authors;
    }
  } catch (error) {
    console.log(error);
  }

  return newRequestData;
};

export const checkIfRequestForMyOrg = (owners: Owners[]) => {
  let isRequestForMyOrg =
    !owners || (owners.length === 0 && isLoggedInUserMultiCenterHead())
      ? false
      : true;
  const userData = ACLService.getUserDetailsFromStorage();
  const userClientId = _.get(userData, "authenticatedUser.clientId._id", "");
  for (let owner of owners) {
    const ownerClientId = _.get(owner, "client.id", "");
    if (userClientId && ownerClientId && userClientId !== ownerClientId) {
      isRequestForMyOrg = false;
      break;
    }
  }
  return isRequestForMyOrg;
};

export const prePublishRequestModifications = (
  requestData: ContentRequest,
  user: any,
  options: { isRequestForMyOrg?: boolean; useRelevantSubjects?: boolean, existingUserIds?: Set<string> } = {}
) => {
  const { isRequestForMyOrg, useRelevantSubjects, existingUserIds = new Set() } = options;
  const newRequestData: ContentRequest = JSON.parse(
    JSON.stringify(requestData)
  );

  const {
    requestInfo: { details, owners },
  } = newRequestData;

  const { subjects, testDetails } = details;
  const assignor = {
    name: `${user.firstName} ${user.lastName}`,
    id: user._id,
  };

  if (subjects) {
    // Use relevant subjectIds if useRelevantSubjects is true
    const relevantSubjectIds = new Set();
    const relevantSubjects = getRelevantSubjects(requestData);
    relevantSubjects.forEach((subject) => relevantSubjectIds.add(subject.id));

    const newSubjects = subjects.map(
      (subject): Subject => {
        if (useRelevantSubjects && !relevantSubjectIds.has(subject.id)) {
          return subject;
        }
        let { questions = [] } = subject;

        questions = questions.map((question) => {
          let { authors = [] } = question;
          if (
            question.code.toString() === QUESTION_TYPES.PARAGRAPH.toString() &&
            requestData.status === "draft"
          ) {
            let paragraphDescription = " <p>";

            question.passage.forEach(({ code, count }, i) => {
              paragraphDescription += `Q${i + 1}: ${count} ${
                QUESTION_TYPE[code.toString()]
              } `;
            });
            paragraphDescription += "</p>";
            question.description += paragraphDescription;
          }
          authors = authors.map((author) => {
            // Add correct assignedDate to each authors in a question, in a subject
            let name = author.name.split("|")[0].trim();
            author.name = name;
            return {
              ...author,
              isEmailTriggered: !existingUserIds.has(author.id),
              assignedDate: new Date().toISOString(),
            };
          });
          return {
            ...question,
            authors,
          };
        });

        // Add assignor to the subjects
        return {
          ...subject,
          assignor,
          questions,
        };
      }
    );

    newRequestData.requestInfo.details.subjects = newSubjects;
  }
  if (testDetails) {
    testDetails.assignor = assignor;
    let { authors = [] } = testDetails;
    authors = authors.map((author) => {
      let name = author.name.split("|")[0].trim();
      author.name = name;
      return {
        ...author,
        isEmailTriggered: !existingUserIds.has(author.id),
        assignedDate: new Date().toISOString(),
      };
    });
    testDetails.authors = authors;
  }

  if (!isRequestForMyOrg && !isLoggedInUserCenterHead()) {
    const newOwners = owners.map((owner) => {
      const newOwner = { ...owner, isEmailTriggered: !existingUserIds.has(owner.client.id) };
      return newOwner;
    });
    newRequestData.requestInfo.owners = newOwners;
  }

  if (isLoggedInUserCenterHead() || isRequestForMyOrg) {
    const userClientIdSet = new Set(
      _.get(user, "clients", []).map(({ id }: any) => id)
    );
    // If centre head then set all owner's status as published
    const newOwners = owners.map((owner: Owners) => {
      if (userClientIdSet.has(owner.client.id)) {
        return {
          ...owner,
          status: "published",
        };
      }
      return owner;
    });
    // @ts-ignore
    newRequestData.requestInfo.owners = newOwners;
  }
  newRequestData.status = "published";
  newRequestData.publishedOn = new Date();

  return newRequestData;
};

export const extractUserIdsFromRequest = (requestData: ContentRequest) => {
  const userIds = new Set<string>();
  if(!requestData) {
    return userIds;
  }
  // Add owner client ids
  const owners: Owners[] = _.get(requestData, 'requestInfo.owners', [])
  owners.forEach(owner => {
    userIds.add(owner.client.id);
  })

  // Add test compiler author userIds
  const testCompilerAuthors: Author[] = _.get(requestData, 'requestInfo.details.testDetails.authors', []);
  testCompilerAuthors.forEach(author => {
    userIds.add(author.id);
  });

  // Add subject author userIds
  const subjects: Subject[] = _.get(requestData, 'requestInfo.details.subjects', []);
  subjects.forEach(subject => {
    const questions: Question[] = _.get(subject, 'questions', []);
    questions.forEach(question => {
      const authors = _.get(question, 'authors', []);
      authors.forEach(author => {
        userIds.add(author.id)
      })
    })
  });

  return userIds;
}

export const getAuthUserClientId = () => {
  const user = ACLService.getUserDetailsFromStorage();
  return _.get(user, "authenticatedUser.clientId._id", "");
};

export const getRelevantSubjects = (requestData: ContentRequest) => {
  const subjects: Subject[] = _.get(
    requestData,
    "requestInfo.details.subjects",
    []
  );
  const { owners } = requestData.requestInfo;
  const userClientId = getAuthUserClientId();

  const owner = owners.find((owner: Owners) => {
    const ownerClientId = _.get(owner, "client.id", "");
    return ownerClientId === userClientId;
  });
  let subjectIdsAssignedToUser = new Set();
  if (owner) {
    (owner as Owners).subjects.forEach((subject) => {
      subjectIdsAssignedToUser.add(subject.id);
    });
  }

  return subjects.filter((subject) => subjectIdsAssignedToUser.has(subject.id));
};

export const getLoggedInUserRole = () => {
  const userData = ACLService.getUserDetailsFromStorage();
  const loggedInUserRole = _.get(
    userData,
    "authenticatedUser.role.role",
    undefined
  );
};
export const validateOrderNotes = (value: string) => {
  const content = extractContent(value);
  return content.trim().length > 4;
};

export const validateBasicDetails = (
  requestData: ContentRequest,
  requestContentType: RequestContentType
) => {
  if (requestContentType === RequestContentType.TEST) {
    return validateTestDetails(requestData);
  } else if (requestContentType === RequestContentType.QUESTION) {
    return validateQuestionDetails(requestData);
  }
};

const validateTestDetails = (requestData: ContentRequest) => {
  const {
    requestInfo: { details },
  } = requestData;
  const { subjects, testDetails, courseTypes } = details;
  if (!testDetails) {
    return false;
  }
  if (!subjects || subjects.length === 0) {
    return false;
  }
  if (!courseTypes || courseTypes.length === 0) {
    return false;
  }
  const { name, type } = testDetails;
  if (!name) {
    return false;
  }
  if (!type || type === "none") {
    return false;
  }

  return true;
};
const validateQuestionDetails = (requestData: ContentRequest) => {
  const {
    requestInfo: { details },
  } = requestData;
  const { subjects, courseTypes } = details;
  if (!subjects || subjects.length === 0) {
    return false;
  }
  if (!courseTypes || courseTypes.length === 0) {
    return false;
  }
  const questions = subjects[0].questions || [];
  if (questions.length === 0) {
    return false;
  }
  return true;
};

export const validateRequestDetails = (requestData: ContentRequest) => {
  const {
    title,
    requestInfo: {
      owners,
      priority,
      startDate,
      endDate,
      type,
      details: { subjects },
    },
  } = requestData;
  if (!title || title.trim().length < 5) {
    return false;
  }

  if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) {
    return false;
  }

  if (!priority) {
    return false;
  }

  if (!subjects || subjects.length === 0) {
    return false;
  }

  if (!owners || owners.length === 0) {
    return false;
  }
  const testCompilerOwner = owners.find(({ type }) => type === "test-compiler");

  if (type === RequestContentType.TEST && !testCompilerOwner) {
    return false;
  }

  // Check if every subject has atleast one owner
  for (let subject of subjects) {
    const { id: subjectId } = subject;
    const subjectOwner = owners.find(({ subjects }) => {
      return subjects && !!subjects.find(({ id }) => id === subjectId);
    });
    if (!subjectOwner) {
      return false;
    }
  }

  return true;
};

export const validateSelectContentOwners = (
  requestData: ContentRequest,
  options: {
    relevantSubjects?: Subject[];
    includeSubjectValidation: boolean;
    includeTestOwnerValidation: boolean;
    handleRelevantOwnerOnly: boolean;
  } = {
    includeSubjectValidation: true,
    includeTestOwnerValidation: true,
    handleRelevantOwnerOnly: false,
  }
) => {
  const {
    relevantSubjects,
    includeSubjectValidation,
    includeTestOwnerValidation,
    handleRelevantOwnerOnly,
  } = options;
  const { requestInfo } = requestData;
  const {
    details: { subjects },
    type,
  } = requestInfo;

  return (
    (!includeSubjectValidation ||
      validateContentAuthorDeadlines(requestInfo, handleRelevantOwnerOnly)) &&
    (!includeSubjectValidation ||
      validateContentOwnersTable(relevantSubjects || subjects)) &&
    (type !== RequestContentType.TEST ||
      !includeTestOwnerValidation ||
      validateTestOwners(requestInfo))
  );
};

const validateContentAuthorDeadlines = (
  requestInfo: RequestInfo,
  handleRelevantOwnerOnly: boolean
) => {
  const { owners } = requestInfo;
  const authUserClientId = getAuthUserClientId();
  const subjectOwner = owners.find((owner) => {
    const { type } = owner;
    const clientId = _.get(owner, "client.id", "");
    if (handleRelevantOwnerOnly && clientId !== authUserClientId) {
      return false;
    }
    return type === "subject" || type === "test-compiler";
  });

  if (!subjectOwner) {
    return false;
  }
  const authorDeadlinesByRoles = subjectOwner.roles;
  if (!authorDeadlinesByRoles) {
    return false;
  }
  const requestEndDate = requestInfo.endDate
    ? new Date(requestInfo.endDate)
    : requestInfo.endDate;

  const requestStartDate = requestInfo.startDate
    ? new Date(requestInfo.startDate)
    : requestInfo.startDate;

  const endDatesValid = validateEndDates(
    authorDeadlinesByRoles,
    requestStartDate,
    requestEndDate,
    true
  );

  return endDatesValid;
};

const validateEndDates = (
  authorDeadlinesByRoles: Roles,
  requestStartDate: Date | string,
  requestEndDate: Date | string,
  allEndDatesRequired: boolean = false
) => {
  if (allEndDatesRequired) {
    const endDateByRoles = Object.values(authorDeadlinesByRoles);

    if (endDateByRoles.length < 5) {
      // Since there are 5 types of authors - creator, evaluator, etc
      return false;
    }
    for (let { endDate } of endDateByRoles) {
      if (!endDate || !isValid(new Date(endDate))) {
        return false;
      }
    }
  }

  const creatorEndDate = new Date(
    _.get(authorDeadlinesByRoles, "creator.endDate", "") || "" // If the endDate is null, use "" so that new Date("") results in invalid date
  );

  const evaluatorEndDate = new Date(
    _.get(authorDeadlinesByRoles, "evaluator.endDate", "") || ""
  );

  const langEvaluatorEndDate = new Date(
    _.get(authorDeadlinesByRoles, "languageEvaluator.endDate", "") || ""
  );
  const moderatorEndDate = new Date(
    _.get(authorDeadlinesByRoles, "moderator.endDate", "") || ""
  );
  const publisherEndDate = new Date(
    _.get(authorDeadlinesByRoles, "publisher.endDate", "") || ""
  );

  const minimumDates = getMinimumDateForRoles(
    authorDeadlinesByRoles,
    new Date(requestStartDate)
  );

  if (
    creatorEndDate < minimumDates.creator.endDate ||
    creatorEndDate > requestEndDate
  ) {
    return false;
  }

  const isValidEvaluatorDate = isValid(evaluatorEndDate);

  if (
    isValidEvaluatorDate &&
    (evaluatorEndDate < minimumDates.evaluator.endDate ||
      evaluatorEndDate > requestEndDate)
  ) {
    return false;
  }

  const isValidLangEvaluatorDate = isValid(langEvaluatorEndDate);

  if (
    isValidLangEvaluatorDate &&
    (langEvaluatorEndDate < minimumDates.languageEvaluator.endDate ||
      langEvaluatorEndDate > requestEndDate)
  ) {
    return false;
  }

  const isValidModeratorEndDate = isValid(moderatorEndDate);

  if (
    isValidModeratorEndDate &&
    (moderatorEndDate < minimumDates.moderator.endDate ||
      moderatorEndDate > requestEndDate)
  ) {
    return false;
  }

  if (
    publisherEndDate < minimumDates.publisher.endDate ||
    publisherEndDate > requestEndDate
  ) {
    return false;
  }

  return true;
};

const validateContentOwnersTable = (subjects: Subject[]) => {
  if (!subjects || subjects.length === 0) {
    return false;
  }
  for (let subject of subjects) {
    const { questions } = subject;
    if (!questions || questions.length === 0) {
      return false;
    }

    for (let question of questions) {
      const { count, syllabus, authors, passage } = question;
      const subjects = _.get(syllabus, "subjects", []);
      if (!count || !parseInt(count.toString())) {
        return false;
      }
      if (!subjects || subjects.length === 0) {
        return false;
      }

      if (passage && passage.length > 0) {
        for (let passageItem of passage) {
          if (!passageItem.count || !parseInt(passageItem.count.toString())) {
            return false;
          }
        }
      }

      const creator = authors.find(({ type }) => type === "creator");
      const publisher = authors.find(({ type }) => type === "publisher");
      if (!creator || !publisher) {
        return false;
      }
    }
  }
  return true;
};

const validateTestOwners = (requestInfo: RequestInfo) => {
  const {
    owners,
    totalCount,
    details: { testDetails },
  } = requestInfo;
  if (!totalCount || !parseInt(totalCount.toString())) {
    return false;
  }
  const testCompiler = owners.find(({ type }) => type === "test-compiler");
  if (!testCompiler) {
    return false;
  }
  const { roles } = testCompiler;
  if (!roles) {
    return false;
  }
  if (!testDetails) {
    return false;
  }
  const { type, authors } = testDetails;
  if (!type || !authors) {
    return false;
  }
  const creator = authors.find(({ type }) => type === "creator");
  const publisher = authors.find(({ type }) => type === "publisher");
  if (!creator || !publisher) {
    return false;
  }
  for (let author of authors) {
    const deadline = _.get(roles, `${author.type}.endDate`, "");
    if (!deadline) {
      return false;
    }
  }
  // const creatorDeadline = _.get(roles, "creator.endDate", "");
  // const publisherDeadline = _.get(roles, "publisher.endDate", "");

  // if (!creatorDeadline || !publisherDeadline) {
  //   return false;
  // }
  const requestEndDate = requestInfo.endDate
    ? new Date(requestInfo.endDate)
    : requestInfo.endDate;

  const requestStartDate = requestInfo.startDate
    ? new Date(requestInfo.startDate)
    : requestInfo.startDate;

  const validEndDates = validateEndDates(
    roles,
    requestStartDate,
    requestEndDate
  );

  return validEndDates;
};

export const getMinimumDateForRoles = (
  roles: Roles,
  requestStartDate: Date
) => {
  const creatorEndDate = new Date(
    _.get(roles, "creator.endDate", "") || "" // If the endDate is null, use "" so that new Date("") results in invalid date
  );

  const evaluatorEndDate = new Date(
    _.get(roles, "evaluator.endDate", "") || ""
  );

  const langEvaluatorEndDate = new Date(
    _.get(roles, "languageEvaluator.endDate", "") || ""
  );
  const moderatorEndDate = new Date(
    _.get(roles, "moderator.endDate", "") || ""
  );

  const minimumEndDates = {
    creator: { endDate: new Date() },
    evaluator: { endDate: new Date() },
    languageEvaluator: { endDate: new Date() },
    moderator: { endDate: new Date() },
    publisher: { endDate: new Date() },
  };

  // The date used as lower bound for all end dates
  // Update this if end date for a role is valid in order
  let minimumDate = requestStartDate;

  minimumEndDates.creator = { endDate: minimumDate };

  // Update minimumDate if valid
  if (isValid(creatorEndDate)) {
    minimumDate = creatorEndDate;
  }

  minimumEndDates.evaluator = { endDate: minimumDate };

  // Update minimumDate if valid
  if (isValid(evaluatorEndDate)) {
    minimumDate = evaluatorEndDate;
  }

  minimumEndDates.languageEvaluator = { endDate: minimumDate };

  // Update minimumDate if valid
  if (isValid(langEvaluatorEndDate)) {
    minimumDate = langEvaluatorEndDate;
  }

  minimumEndDates.moderator = { endDate: minimumDate };

  // Update minimumDate if valid
  if (isValid(moderatorEndDate)) {
    minimumDate = moderatorEndDate;
  }

  minimumEndDates.publisher = { endDate: minimumDate };

  return minimumEndDates;
};

export const hasWorkStartedForASubject = (subjectQuestions: Question[]) => {
  for (let question of subjectQuestions) {
    const contentRequestItemsId = _.get(
      question,
      "contentRequestItemsId",
      undefined
    );
    if (contentRequestItemsId !== undefined && contentRequestItemsId !== null) {
      return true;
    }
  }
  return false;
};
export const hasTestOwnerStartedWork = (requestData: ContentRequest) => {
  const contentRequestItemsId = _.get(
    requestData,
    "requestInfo.details.testDetails.contentRequestItemsId",
    undefined
  );
  if (contentRequestItemsId !== undefined && contentRequestItemsId !== null) {
    return true;
  }
  return false;
};

export const getRequestCreatorName = (request: ContentRequest) => {
  const createdBy = _.get(request, "aclMetaData.createdBy.id");
  if (!createdBy) {
    return "NA";
  }
  return `${createdBy.firstName} ${createdBy.lastName}`;
};

export const getAssignorName = (requestData: ContentRequest) => {
  const requestType = _.get(requestData, "requestInfo.type", "test");
  if (requestType === "test") {
    return _.get(
      requestData,
      "requestInfo.details.testDetails.assignor.name",
      ""
    );
  }
  return _.get(
    requestData,
    "requestInfo.details.subjects[0].assignor.name",
    ""
  );
};

export const generateDefaultData = (
  contentRequestId: any,
  content_id: any,
  type: any,
  contentRequestItemsId: any
) => {
  const data = {
    contentRequestId: contentRequestId,
    role: "creator",
    contentType: type,
    contentRequestItemId: contentRequestItemsId,
    content_id: content_id,
  };
  return data;
};
export const getAllRequestOwnerNames = (
  data: string[],
  { truncateLength, displayCount }: any
) => {
  //  const owners = _.get(this.props.contentRequest, 'requestInfo.owners','');
  // If Required to show only unique names
  let isNameTruncated = false;

  const requestOwnerNames: any = new Set();
  // const requestOwnerNames:any=[];
  for (let owner of data) {
    requestOwnerNames.add(owner);
    // requestOwnerNames.push(owner.client.name);
  }
  const ownerNamesInArray: any = [...requestOwnerNames];
  let isNamesMoreThan2 = ownerNamesInArray.length > displayCount ? true : false;
  let untruncatedNames = ownerNamesInArray.slice(0, displayCount);
  let namesToReturn = untruncatedNames
    .map((name: string) => {
      let trucatedValue = _.truncate(name, { length: truncateLength });
      if (name.length != trucatedValue.length) {
        isNameTruncated = true;
      }
      return trucatedValue;
    })
    .join(" ,");
  namesToReturn = namesToReturn.length > 0 ? namesToReturn : "N/A";
  let tooltiptitle = "";
  let tooltipDetail = "";
  if (isNamesMoreThan2) {
    let extraLength = ownerNamesInArray.length - displayCount;
    tooltipDetail = ownerNamesInArray.map((name: string) => <div>{name}</div>);
    tooltiptitle = ` +${extraLength}`;
  }
  untruncatedNames = untruncatedNames.map((name: string) => <div>{name}</div>);
  return (
    <span>
      {isNameTruncated ? (
        <Tooltip style={{ cursor: "pointer" }} title={untruncatedNames}>
          <span>{namesToReturn}</span>
        </Tooltip>
      ) : (
        namesToReturn
      )}
      {isNamesMoreThan2 && (
        <Tooltip style={{ cursor: "pointer" }} title={tooltipDetail}>
          <span>{tooltiptitle}</span>
        </Tooltip>
      )}
    </span>
  );
};

export const checkUserRoleMap = (
  userRoleMap: any,
  currentAuthorId: string,
  currentRole: string,
  prevAuthorId: string
) => {
  // If user exist :-
  // If user exist with same role :- count++ return;
  // If user exist with different role:- show error msg:- with user exist with different role{role} return ;
  // else user not exist :-
  //Decrement the count of prev user for that type of role and form:-
  // If count===0 delete the user Key
  // Add cuurent user key with {"{role}":1}
  const newUserRoleMap = { ...userRoleMap };
  console.log({ currentRole, currentAuthorId, prevAuthorId, newUserRoleMap });
  if (!_.isEmpty(currentAuthorId)) {
    if (newUserRoleMap.hasOwnProperty(currentAuthorId)) {
      const prevRole = newUserRoleMap[currentAuthorId].type;
      console.log("currentAuthorId", newUserRoleMap[currentAuthorId]);
      if (prevRole !== currentRole) {
        return {
          status: "error",
          msg: `The selected ${currentRole} is already defined as ${prevRole} in this request`,
        };
      }
      newUserRoleMap[currentAuthorId] = {
        type: currentRole,
        count: newUserRoleMap[currentAuthorId].count + 1,
      };
    } else {
      // @ts-ignore
      newUserRoleMap[currentAuthorId] = { type: currentRole, count: 1 };
    }
  }
  if (!_.isEmpty(prevAuthorId) && newUserRoleMap.hasOwnProperty(prevAuthorId)) {
    let count = newUserRoleMap[prevAuthorId].count;
    if (count == 1) {
      delete newUserRoleMap[prevAuthorId];
    } else {
      newUserRoleMap[prevAuthorId] = {
        type: newUserRoleMap[prevAuthorId].type,
        count: newUserRoleMap[prevAuthorId].count - 1,
      };
    }
  }
  return { status: "success", userRoleMap: newUserRoleMap };
};
export const getFormatedDate = (DateString: any) => {
  return moment(DateString).format("h:mm A, D MMM YYYY");
};

export const checkValidClientUser = (
  authorsList: any,
  author: { name: string; id: string },
  authorType: any,
  otherQuestionData?: any,
  currentAuthorData?: string
) => {
  let arrayOfAuthors = Object.values(authorsList);
  let valid = true;
  let selected = author.name.substring(author.name.indexOf("|") + 1).trim();
  arrayOfAuthors.forEach((ele: any) => {
    let client = ele.name.substring(ele.name.indexOf("|") + 1).trim();
    if (client !== selected) {
      valid = false;
    } else {
      valid = valid && true;
    }
  });
  let otherData =
    otherQuestionData &&
    otherQuestionData.filter((data: any) => data._id !== currentAuthorData);
  otherData &&
    otherData.forEach((quesData: any) => {
      quesData &&
        quesData.authors &&
        quesData.authors.forEach((ele: any) => {
          let client = ele.name.substring(ele.name.indexOf("|") + 1).trim();
          if (client !== selected) {
            valid = false;
          } else {
            valid = valid && true;
          }
        });
    });
  return valid;
};
// export const removeUserFrom
